
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 18 18","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.75 13.5h10.5V8.274C14.25 5.36 11.9 3 9 3S3.75 5.361 3.75 8.274V13.5zM9 1.5c3.728 0 6.75 3.033 6.75 6.774V15H2.25V8.274C2.25 4.533 5.272 1.5 9 1.5zM7.125 15.75h3.75a1.875 1.875 0 01-3.75 0z","fill":"currentColor"}})])
          )
        }
      }
    